import { useState } from "react";
import { Dispatch } from "react";
import { Category, SubCategory } from "../../types";

interface SubCategoryScoreCardProps {
  subCategoryName: string;
  setScoreCard: Dispatch<any>;
  scoreCard: {};
  scoreStoragekey: string;
  scorePageState: string;
  currentRole: number;
  previousScore: number | null;
  categoryId: number;
  subCategoryId: number;
  subCategoryDesc: string;
  isPageViewOnly:boolean;
}

const SubCategoryScoreCard: React.FC<SubCategoryScoreCardProps> = ({
  subCategoryName,
  setScoreCard,
  scoreCard,
  scoreStoragekey,
  scorePageState,
  currentRole,
  previousScore = null,
  categoryId,
  subCategoryId,
  subCategoryDesc,
  isPageViewOnly,
}) => {
  const subScores = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [currActiveScore, setCurrActiveScore] = useState<number | null>(
    previousScore
  );

  const handleScoreClick = (selectedScore: number) => {
    setCurrActiveScore(selectedScore);

    setScoreCard((previousValues: any) => {
      const updatedScoreCard = { ...previousValues };

      const category = updatedScoreCard.scorecard.categories.find(
        (cat: Category) => cat.id === categoryId
      );

      if (category) {
        const subCategory = category.subcategories.find(
          (subCat: SubCategory) => subCat.id === subCategoryId
        );

        if (subCategory) {
          subCategory.subScores = [
            {
              score: selectedScore,
            },
          ];
        }

        const totalSubScores = category.subcategories.reduce(
          (acc: number, subCat: SubCategory) => {
            return (
              acc +
              (subCat.subScores?.reduce(
                (subAcc: number, subScore) => subAcc + subScore.score,
                0
              ) || 0)
            );
          },
          0
        );

        category.scores = [
          {
            ...category.scores[0],
            category_total_scores: totalSubScores,
          },
        ];
      }

      return updatedScoreCard;
    });
    if (localStorage.hasOwnProperty(scoreStoragekey) && scorePageState == 'create' && currentRole == 5){
      localStorage.setItem(scoreStoragekey, JSON.stringify(scoreCard));
    } 
  };

  return (
    <>
      <div className="div-score-section">
        <p className="paragraph-3">
          <strong>{subCategoryName}&nbsp;</strong>
          {subCategoryDesc}
        </p>
        <div className="div-block-4">
          <div
            id="w-node-e37c566c-7a7e-a3ec-2f54-12b2c6960c6e-38e776aa"
            className="w-layout-layout quick-stack-2 wf-layout-layout"
          >
            {subScores.map((sc, i) => (
              <div
                id="w-node-e37c566c-7a7e-a3ec-2f54-12b2c6960c6f-38e776aa"
                className={`w-layout-cell overflow-hidden ${
                  currActiveScore === sc ? "activeScore" : ""
                }`}
                key={i}
              >
                <a
                  href="#"
                  className="button w-button"
                  onClick={() => {
                    if(!isPageViewOnly) handleScoreClick(sc);
                  }}
                >
                  {sc}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubCategoryScoreCard;
